import type { Error } from '../types';
import { CONTAIN_LATIN_AND_SPANISH_CHARACTERS_ONLY } from '../utils/regex';

import { TXTWCL_Special_characters_are_not_all_ELL } from './mustContainOnlyLatinAndSpanishCharacters.messages';

export const mustContainOnlyLatinAndSpanishCharacters =
  (allowEmpty = false) =>
  (value: string): Error => {
    const valid = CONTAIN_LATIN_AND_SPANISH_CHARACTERS_ONLY.test(value);
    return {
      valid: allowEmpty ? !value || valid : valid,
      message: TXTWCL_Special_characters_are_not_all_ELL
    };
  };
